// Ce fichier est généré automatiquement par scripts/generate-service-registers.js
// Ne pas modifier manuellement - vos changements seront écrasés
// Pour régénérer : pnpm run generate:service-registers

// ================================
// IMPORTS DES SERVICES
// ================================
import { IrveService } from "./irve.service"

// ================================
// EXPORTS DES SERVICES
// ================================
export * from "./irve.service"

// ================================
// REGISTRY DES SERVICES
// ================================
export const irveServiceRegistry = {
    irve: new IrveService(),
} as const

// ================================
// TYPES DU REGISTRY
// ================================
export type IrveServiceRegistry = typeof irveServiceRegistry
